import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Footer() {
  return (
    <footer className="bg-foreground-900 text-background-200">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-500 text-background-50">
                <i className="ri-shield-check-line text-lg"></i>
              </div>
              <span className="font-heading text-lg font-bold text-background-50 whitespace-nowrap">
                网络安全指南
              </span>
            </div>
            <p className="text-sm text-background-400 leading-relaxed">
              致力于普及网络安全知识，帮助公众识别和防范黄色网站，保护个人隐私与家庭和谐，营造清朗网络空间。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-background-50 mb-4">
              <a href="#category-list">内容分类</a>
            </h4>
            <ul className="space-y-2">
              {categories.map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-background-50 mb-4">
              <a href="#quick-links">快速链接</a>
            </h4>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap">
                  首页
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap">
                  关于我们
                </Link>
              </li>
              <li>
                <Link to="/category/huangwang-weihai" className="text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap">
                  黄网危害
                </Link>
              </li>
              <li>
                <Link to="/category/fangfan-cuoshi" className="text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap">
                  防范措施
                </Link>
              </li>
              <li>
                <Link to="/category/qingshaonian-baohu" className="text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap">
                  青少年保护
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-background-50 mb-4">
              <a href="#contact-info">联系方式</a>
            </h4>
            <ul className="space-y-3 text-sm text-background-400">
              <li className="flex items-start gap-2">
                <i className="ri-mail-line mt-0.5 shrink-0"></i>
                <span>contact@wangluoanquan.org</span>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-phone-line mt-0.5 shrink-0"></i>
                <span>12321 网络不良信息举报热线</span>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-global-line mt-0.5 shrink-0"></i>
                <a
                  href="https://www.12377.cn"
                  target="_blank"
                  rel="noopener noreferrer nofollow"
                  className="hover:text-primary-400 transition-colors"
                >
                  www.12377.cn
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-8 border-t border-background-600/30 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-sm text-background-500">
            &copy; {new Date().getFullYear()} 网络安全指南. 版权所有.
          </p>
          <div className="flex items-center gap-4">
            <a
              href="https://www.12377.cn"
              target="_blank"
              rel="noopener noreferrer nofollow"
              className="text-sm text-background-500 hover:text-primary-400 transition-colors whitespace-nowrap"
            >
              举报中心
            </a>
            <span className="text-background-600">|</span>
            <span className="text-sm text-background-500 whitespace-nowrap">
              京ICP备XXXXXXXX号
            </span>
          </div>
        </div>
      </div>
    </footer>
  );
}